import React, { Component } from 'react'
import { Input, Pagination, Checkbox, Button, Icon, Switch, ConfigProvider } from '@tinper/next-ui'
import _ from 'lodash';
import './style';
import { REFER_TYPE } from '../../utils/refer_context/referType';
import CommonPickerPc from '../CommonPicker';
import { getJsonObj, removeRepeat } from '../../utils';
import { v4 as uuid } from 'uuid';
import { TableStore, RowStore, PageStore } from 'ynf-core-engine'
import render from 'ynf-core-engine/render'

const X_LIB_CODE = 'ynf-lib-base' // 组件库名

export default class ReferTablePc extends Component {
  constructor (props) {
    super(props);
    this.referContext = props.referContext;
    try {
      this.billNo = this.referContext.props.pageStore.params.billNo;
      this.busiObj = this.referContext.props.pageStore.params.busiObj;
    } catch {
      console.error("没配置pageStore!")
    }
    this.key = this.referContext.metaDataObj.cEntityKeyFld || 'id'; // 参照主键
    this.rootStore = {}
    this.rootStore.referTableStore = new TableStore({}, this.rootStore, null, this.key)
    this.rootStore.pageStore = new PageStore({
      ...this.referContext.props.pageStore,
      enumData: this.referContext.metaDataObj.enumData,
      userDefines: this.referContext.metaDataObj.userDefines
    });
    this.rootStore.context = this.referContext.props.pageStore.rootStore?.context
  }

  state = {
    dataSource: [], // 列表数据
    totalDataSource: [], // 全部数据
    selectedKeys: [], // 当前选中数据的id集合
    pageInfo: {
      pageIndex: 1,
      pageSize: 10,
      total: 0
    },
    searchKey: this.props.referContext?.searchKey || '', // 查询关键词
    exactQuery: false, // 精准搜索
    stopStatus: false, // 显示停用状态
    onlySelected: false, // 只看已选
    selectedList: [], // 当前选中数据集合
    alias: uuid(), // 别名
    searchResultData: [], // 搜索结果数据(前端分页搜索时用)
    favoriteList: [] // 收藏数据集合
  }

  componentDidMount () {
    // 前端分页 或者 不分页
    if (this.referContext.props.frontEndPagination || this.referContext.props.nonPagination) {
      this.getAllDataList(); // 获取全部数据
    } else { // 后端分页
      this.onChangePageIndex(1)
    }
  }

  componentWillReceiveProps(nextProps) {
    // if (nextProps.path) {
      if (this.referContext.props.frontEndPagination || this.referContext.props.nonPagination) this.getAllDataList()
      else this.onChangePageIndex(1)
    // }
  }

  // 获取全部数据
  getAllDataList = async () => {
    this.referContext.props.pageStore.startLoading()
    let { exactQuery, stopStatus } = this.state;
    let _res = await this.referContext.getListData({
      pageInfo: { pageIndex: 1, pageSize: 999999, total: 0 },
      searchKey: '',
      exactQuery,
      stopStatus: this.props.showStopStatus ? stopStatus : undefined,
      referType: REFER_TYPE.TABLE,
      dataType: 'grid',
      path: this.props.path === 'all' ? '' : this.props.path,
      billnum: this.billNo,
      busiObj: this.busiObj
    });
    let totalDataSource = _res.dataSource
    this.setState({ totalDataSource, pageInfo: { pageIndex: 1, pageSize: this.state.pageInfo.pageSize, total: _res.total } }, () => {
      if (!this.referContext.props.nonPagination) {
        this.getDataListFrontEnd(this.state.pageInfo)
      } else {
        this.setState({ dataSource: totalDataSource });
      }
    });
    this.referContext.props.pageStore.endLoading()
  }

  // 前端分页
  getDataListFrontEnd = (pageInfo) => {
    this.referContext.props.pageStore.startLoading()
    let { totalDataSource, searchResultData, searchKey } = this.state;
    if (searchKey.length !== 0) {
      totalDataSource = searchResultData;
    }
    const dataSource = totalDataSource.slice((pageInfo.pageIndex - 1) * pageInfo.pageSize, pageInfo.pageIndex * pageInfo.pageSize);
    this.setState({ dataSource });
    this.referContext.props.pageStore.endLoading()
  }

  // 获取列表数据
  getDataList = async (pageInfo) => {
    this.referContext.props.pageStore.startLoading()
    const { exactQuery, stopStatus, searchKey } = this.state;
    const { dataSource, total } = await this.referContext.getListData({
      pageInfo, searchKey, exactQuery,
      stopStatus: this.props.showStopStatus ? stopStatus : undefined,
      referType: REFER_TYPE.TABLE,
      dataType: 'grid',
      path: this.props.path === 'all' ? '' : this.props.path,
      billnum: this.billNo,
      busiObj: this.busiObj
    });
    // 后端分页伪造totalDataSource数据给setEchoData用, 不是全量数据
    this.setState({
      dataSource,
      pageInfo: { ...pageInfo, total },
      totalDataSource: [...dataSource, ...this.referContext.currentValue],
      selectedKeys: this.referContext.currentValue.map(i => i[this.key])
    });
    this.referContext.props.pageStore.endLoading()
  }

  // 查询关键词
  onSearch = (flag) => {
    if (this.referContext.props.frontEndPagination || this.referContext.props.nonPagination) {
      // 显示停用
      if (flag === 'stopStatus') this.getAllDataList()
      else this.frontEndSearch()
    } else {
      this.onChangePageIndex(1)
    }
    // 用户自定义表检索回调
    this.referContext.props.onSearchTableRef?.(this.state.searchKey)
  }
  
  // 前端搜索
  frontEndSearch = () => {
    const showFields = this.props.metaData?.filter(item => !item.bHidden).map(item => item.cItemName) // 显示字段
    const { totalDataSource, searchKey, exactQuery } = this.state;
    let searchResultData = totalDataSource.filter(item => {
      for (let i = 0; i < showFields.length; i++) {
        let v = item[showFields[i]];
        if (exactQuery) { // 精确搜索
          if (v == searchKey) return true;
        } else { // 模糊搜索
          if (v.toString().indexOf(searchKey) > -1) return true;
        }
      }
      return false;
    })
    this.setState({ searchResultData, pageInfo: { pageIndex: 1, pageSize: this.state.pageInfo.pageSize, total: searchResultData.length } }, () => {
      this.getDataListFrontEnd(this.state.pageInfo)
    });
  }

  // 监听选择
  onSelectRow = (row, action) => {
    // 用户自定义回调
    this.referContext.props.onChangeSelect?.({
      oldValue: this.referContext.getCurrentValue(),
      currentValue: row
    });
    const { dataSource } = this.state;
    this.referContext.select(row) // 将选择的值存入逻辑层
    // 如果是下拉展示方式, 则单选不用点确定直接关闭, 有path是树表, 树表不能用下拉
    if ((!this.props.isMultiple && this.props.path === undefined && this.referContext.showPopover) ||
        (!this.props.isMultiple && action === 'onDoubleClick')) { // 单选双击也可直接关闭
      this.referContext.okClick();
    }
    // 更新选择数据
    let selectRowData = this.referContext.getCurrentValue();
    let selectedKeys = selectRowData.map(item => item[this.key]);
    this.setState({ selectedKeys });
  }

  // 渲染列表配置项
  getTableConfig = () => {
    const { fieldid, fieldidPrefix, cardBillno } = this.referContext.props || {};
    const { alias, onlySelected, selectedList, dataSource } = this.state;
    let value = onlySelected ? selectedList : dataSource;
    this.rootStore.referTableStore.clear() // 先清空
    value.map((item, index) => {
      this.rootStore.referTableStore.addRow(item)
    })
    let columns = !this.props.newRefMeta ? this.getTableColumn(this.props.metaData) : {};
    // columns.columns.unshift(this.setFavorite(value)) // 收藏列
    let config = {
      fieldid,
      fieldidPrefix,
      store: this.rootStore.referTableStore,
      libCode: X_LIB_CODE, // 组件库
      controlType: 'Table', // 组件类型
      alias: this.props.path ? this.props.path : alias, // 组件唯一标识 有path是树表, 树表切换时不能用同一个alias
      children: columns.columns,
      isSort: true, // 表格排序
      isSingleFind: false, // 该列是否启用查找定位
      readOnly: true,
      autoCheckedByClickRows: true, // 表格行点击事件，是否自动勾选
      lockable: false, // 是否开启锁定列功能
      getSelectedDataFunc: this.getSelectedDataFunc,
      onRowDoubleClick: this.onRowDoubleClick,
      onRowHrefClick: ({ rowData, rowIndex }) => { this.onRowHrefClick({ rowData, rowIndex, columns }) }
    }
    if (this.props.newRefMeta) { // 新协议
      config.children = this.getTableColumn(this.props.metaData).columns;
    }

    if (Array.isArray(config.children) && cardBillno) {
      config.children = config.children.concat([{
        "libCode": "ynf-lib-base",
        "visible": true,
        "controlType": "ToolBar",
        "caption": "编辑", // 需要多语翻译
        "children": [
          {
            "libCode": "ynf-lib-base",
            "onClick": this.addRefData,
            "visible": true,
            "caption": "新增", //需要多语翻译
            "compType": "xbutton",
            "controlType": "Button",
            "orderNum": 1,
            "disabled": false,
          },
          {
            "libCode": "ynf-lib-base",
            "onClick": this.editRefData,
            "visible": true,
            "caption": "编辑", // 需要多语翻译
            "compType": "xbutton",
            "controlType": "Button",
            "disabled": false,
          }
        ],
      }])
    }

    return config;
  }

  addRefData = (e, rowStore) => { // page122List-refertable1Page
    const { cardBillno = '' } = this.referContext.props || {};
    const billNo = this.referContext.cCardKey || cardBillno
    if (this.referContext.cCardKey) { // mdf单据
      // const domainKey = this.referContext.props.pageStore.params.domainKey;
      // const component = <iframe
      //   title=""
      //   src={encodeURI(`${window.location.origin}/mdf-node/meta/voucher/${billNo}?domainKey=${domainKey}&mode=add`)}
      //   // src={`https://bip-daily.yonyoucloud.com/mdf-node/meta/voucher/bd_receiveagreement/?domainKey=basedoccenter&mode=add`}
      //   width="1168"
      //   height="760"
      //   frameBorder="0"
      //   allowFullScreen
      //   sandbox='allow-same-origin allow-scripts'
      // />
      // this.referContext.props.pageStore.openModal({ uiType: 'component', component: component, showModal: true, zIndex: 1700 })
      return 
    }
    try {
      this.referContext.props.pageStore.openModal({ billNo: billNo, zIndex: 1700, params: { mode: 'add'}})
    } catch {}
  }
  editRefData = (e, rowStore) => {
    const rowKey = rowStore.rowStore.rowKey
    const { cardBillno = '' } = this.referContext.props || {};
    const billNo = this.referContext.cCardKey || cardBillno
    if (this.referContext.cCardKey && cardBillno) { // mdf单据
      // const domainKey = this.referContext.props.pageStore.params.domainKey;
      // const component = <iframe
      //   title=""
      //   src={encodeURI(`${window.location.origin}/mdf-node/meta/voucher/${billNo}/${rowKey}?domainKey=${domainKey}&mode=add`)}
      //   // src={`https://bip-daily.yonyoucloud.com/mdf-node/meta/voucher/aa_vendor/1907843138990899202?domainKey=yssupplier&mode=edit`}
      //   width="1168"
      //   height="760"
      //   frameBorder="0"
      //   allowFullScreen
      //   sandbox='allow-same-origin allow-scripts'
      // />
      // this.referContext.props.pageStore.openModal({ uiType: 'component', component: component, showModal: true, zIndex: 1700 })
      return 
    }
    try {
      this.referContext.props.pageStore.openModal({ billNo: billNo, zIndex: 1700, query: { billId: rowKey }, params: { mode: 'edit' }})
    } catch {}
  }

  // 加收藏按钮
  setFavorite = (data) => {
    const { favoriteList } = this.state;
    let icon = "uf-star-o";
    data.map(item => {
      if (favoriteList.indexOf(item[this.key]) > -1) {
        icon = "uf-star";
      }
    })
    return {
      "alias": "Icons0ni",
      libCode: 'ynf-lib-basic',
      controlType: 'Icons',
      caption: "",
      width: 35,
      icon,
      onClick: (e, { rowStore: rowData }) => {
        console.log('rowData.getValue', rowData, rowData.getValue);
        rowData = rowData.getValue()
        e & e.stopPropagation()
        favoriteList.push(rowData[this.key])
      }
    }
  }

  // Table 单选回调 返回当前选中的数据数组
  getSelectedDataFunc = (selectedList) => {
    if (!this.props.isMultiple) { // 该回调在多选时也会执行,所以过滤一下
      selectedList = selectedList.getValue();
      selectedList ? this.onSelectRow([selectedList]) : this.onSelectRow([])
    }
  }

  // Table 双击回调
  onRowDoubleClick = (record) => {
    if (!this.props.isMultiple) { // 单选时直接选中并关闭弹窗
      let selectedList = record.rowStore.getValue();
      selectedList ? this.onSelectRow([selectedList], 'onDoubleClick') : this.onSelectRow([], 'onDoubleClick')
    }
  }

  // Table 点击可跳转的列
  onRowHrefClick = ({ rowData, rowIndex, columns }) => {
    const busiObj = this.referContext.props.pageStore.params.busiObj;
    const domainKey = this.referContext.props.pageStore.params.domainKey;
    const serviceCode = this.referContext.props.pageStore.query.serviceCode;
    let url = `/mdf-node/meta/Voucher/${columns.billno}/${rowData.id}?domainKey=${domainKey}&busiObj=${busiObj}&serviceCode=${serviceCode}`;
    let elementId = document.getElementById('yyrefer-table-column-detail');
    if (!elementId) {
      const container = document.createElement('div')
      container.id = 'yyrefer-table-column-detail'
      elementId = container;
      document.body.append(container)
    }
    ReactDOM.render(
      <ConfigProvider locale={this.referContext.props.pageStore.rootStore.context?.locale || 'zh_CN'}>
        <CommonPickerPc
          title={this.referContext.props.modalTitle || this.referContext.props.caption || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00037', '详情', undefined, {returnDom: true, placement: 'top'})}
          footer={null}
          close={() => { elementId && ReactDOM.unmountComponentAtNode(elementId); }}
          width={this.referContext.props.detailModalWidth || '90%'}
          height={this.referContext.props.detailModalHeight || '556px'}
          visible={true}
        >
          <iframe src={location.origin + url} width="100%" height="100%" style={{border: 'none'}}></iframe>
        </CommonPickerPc>
      </ConfigProvider>,
      elementId
    );
  }

  // 多选配置项
  getRowSelection = () => {
    return {
      multiple: this.props.isMultiple,
      selectedRowKeys: this.state.selectedKeys, // 指定选中项的 key 数组，需要和 onChange 进行配合
      onSelect: this.onSelect,
      onSelectAll: this.onSelectAll,
      onChange:()=>{}
    }
  }

  // Table 选择回调(所选行数据, true正选/false反选)
  onSelect = ({ rowStore: rowData }, isSelected) => {
    if (this.props.isMultiple) {
      rowData = rowData.getValue()
      if (isSelected) { // 正选
        this.onSelectRow(removeRepeat([...this.referContext.getCurrentValue(), rowData], this.key));
      } else { // 反选
        let selectedList = this.referContext.getCurrentValue();
        let filterSelect = selectedList.filter(item => item[this.key] !== rowData[this.key]);
        this.onSelectRow(removeRepeat(filterSelect, this.key));
      }
    }
  }

  // Table 选择所有回调
  onSelectAll = (selected, selectedRows, changeRows) => {
    if (selected) { // 正选
      let _selectedRows = selectedRows.map(item => item.rowStore?.getValue())
      this.onSelectRow(removeRepeat([...this.referContext.getCurrentValue(), ..._selectedRows], this.key));
    } else { // 反选
      let selectedList = this.referContext.getCurrentValue();
      let changeRowsKeys = changeRows.map(item => {
        let value = item.rowStore?.getValue();
        return value[this.key];
      });
      for (let i = 0; i < selectedList.length; i++) {
        if (changeRowsKeys.indexOf(selectedList[i][this.key]) > -1) {
          selectedList.splice(i, 1);
          i--;
        }
      }
      this.onSelectRow(removeRepeat(selectedList, this.key));
    }
  }

  // 表头数据兼容
  getTableColumn = (metaData) => {
    let billno = '';
    let columns = metaData?.filter(item => !item.bHidden && item.controlType?.toLocaleLowerCase() !== 'toolbar').map(item => { // columns metaData元数据
      item = JSON.parse(JSON.stringify(item))
      item.alias = 'yyrefertablecolunm' + uuid();
      item.sorter = true; // 列排序
      item.readOnly = true; // 全都是只读不能修改
      item.store = 'referTableStore';
      item.caption_resid = item.cShowCaptionResid;
      // 该列不展示
      if (item.bShowIt === false || item.visible === false) item.visible = false;
      else item.visible = true;
      if (item.bJointQuery) { // 要跳转的列
        item.isHref = true; // 设为可点击的链接
        const cExtProps = getJsonObj(item.cExtProps);
        const jointQueryOpt = getJsonObj(cExtProps.jointQueryOpt)
        billno = jointQueryOpt.billno
      }
      if (this.props.newRefMeta) { // 新协议
        if (item.modelPath) item.storeField = item.modelPath[item.modelPath.length - 1];
        if (item.controlType === 'PictureUpload' || item.controlType === 'Upload') item.showType = '2';
        if (item.controlType === 'Enumerate') item.enumData = `mobx://rootStore.pageStore.enumData.${item.enumType}`;
      } else {
        item.modelPath = [item.cItemName];
        item.storeField = item.cItemName;
        item.cControlType = item.cControlType.toLocaleLowerCase();
        if (item.cControlType === 'tag' || item.cControlType === 'refer') { // 渲染该列为参照组件
          item.selectType = item.cControlType === 'tag' ? 'multiple' : 'single'
          item.controlType = 'ReferInput'
          item.libCode = 'ynf-fw-apcom-lib';
          item.caption = item.cShowCaption;
          item.refCode = item.cRefType
          let showRefReturn = item.refReturn;
          if (item.cControlType === 'tag') {
              const keyMap = JSON.parse(item.cRefRetId);
              for (const res in keyMap) {
              if (keyMap[res] === showRefReturn) {
                showRefReturn = res;
              }
            }
            item.refReturn = showRefReturn;
            item.dataSourceAlias = item.cDataSourceName;
          }
          if (item.depend && item.characterKey) {
            // showRefReturn = 'name'
            item.cItemName = item.cItemName + '_name'
          }
          let refReturn = showRefReturn || 'name';
          item.refReturnArr = `{"${refReturn}": "${item.store},${item.cItemName}"}`;
        } else if (item.cControlType === 'optionwidget' || item.cControlType === 'radio' || item.cControlType === 'select') { // 渲染该列为枚举组件
          item.controlType = 'Enumerate'
          item.libCode = 'ynf-lib-base';
          item.caption = item.cShowCaption
        } else {
          item.controlType = 'Input'
          item.libCode = 'ynf-lib-base';
          item.caption = item.cShowCaption
        }
      }
      return item
    }) || [];
    return { columns, billno }
  }

  // 切换页码
  onChangePageIndex = (pageIndex) => {
    this.setState({ pageInfo: { ...this.state.pageInfo, pageIndex } }, () => {
      if (this.referContext.props.frontEndPagination) { // 前端分页
        this.getDataListFrontEnd(this.state.pageInfo);
      } else { // 后端分页
        this.getDataList(this.state.pageInfo);
      }
    })
    // 用户自定义分页回调
    this.referContext.props.onChangePageIndex?.(pageIndex);
  }

  // 选择每页多少条的回调函数
  onPageSizeChange = (activePage, pageSize) => {
    // console.log(activePage, pageSize);
    this.setState({ pageInfo: { pageIndex: 1, pageSize, total: 0 } }, () => {
      if (this.referContext.props.frontEndPagination) { // 前端分页
        this.getDataListFrontEnd(this.state.pageInfo);
      } else { // 后端分页
        this.getDataList(this.state.pageInfo);
      }
    })
  }

  // 清空并且查询
  clearAndSearch = () => {
    this.setState({ searchKey: '' }, () => { this.onSearch() });
  }

  // 清空已选
  clearSelected = () => {
    this.onSelectRow([]);
  }

  // 只看已选
  showSelected = (val) => {
    this.setState({ onlySelected: val, selectedList: this.referContext.getCurrentValue() })
  }

  getFieldId = () => {
    const { fieldid, fieldidPrefix } = this.referContext.props || {};
    return fieldid || fieldidPrefix;
  };

  inputChange = (val) => {
    this.referContext.searchKey = val
    this.setState({ searchKey: val })
  }

  render () {
    const { dataSource, searchKey, pageInfo, exactQuery, stopStatus, selectedKeys, onlySelected, selectedList } = this.state;
    const { parentAlias = '' } = this.referContext.props;
    const { alias } = this.referContext.props;
    return (
      <div className='refer-table-list'>
        {/* 搜索 */}
        {/* {
          this.props.activeKey === 'all' && */}
        <div className='refer-search-container'>
          <Input value={searchKey} onSearch={this.onSearch} type='search' onChange={(val) => this.inputChange(val) } className='refer-search-input' placeholder={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00035', '请输入关键词', undefined, {returnDom: true, placement: 'top'})} fieldid={`${this.getFieldId()}_table_search`} />
          <Button bordered icon={<Icon type="uf-chongzhi1" />} onClick={this.clearAndSearch} className='refer-search-backbtn' fieldid={`${this.getFieldId()}_table_search_btn`} />
          <Checkbox antd checked={exactQuery} onClick={(e) => { this.setState({ exactQuery: e.target.checked })}} className='refer-search-checkbox' fieldid={`${this.getFieldId()}_exactquery`}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00036', '精准搜索', undefined, {returnDom: true, placement: 'top'})}</Checkbox>
          {
            // 只有查询区才展示"显示停用"按钮
            parentAlias.indexOf('ConvenientQuery') > -1 && this.props.showStopStatus ? 
            <Checkbox antd checked={stopStatus} onClick={(e) => { this.setState({ stopStatus: e.target.checked }, () => { this.onSearch('stopStatus') }) }} className='refer-search-checkbox' fieldid={`${this.getFieldId()}_stopstatus`}>
              {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00038', '显示停用', undefined, {returnDom: true, placement: 'top'})}
            </Checkbox>
            : null
          }
        </div>
        {/* } */}
        {
          render({
            ...this.getTableConfig(),
            rowSelection: this.getRowSelection()
          }, {
            rootStore: this.rootStore
          })
        }
        {/* {
          this.props.activeKey === 'all' && */}
        <div className='flex-wrap'>
          {
            this.props.isMultiple && !this.referContext.props.hideSelectedInfo ?
            <div className='table-selected-rows-content'>
              <Switch size="sm" className='table-selected-rows-switch' checked={this.state.onlySelected} onChange={this.showSelected} fieldid={`${this.getFieldId()}_table_selectall`} />
              <span>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00039', '已选', undefined, {returnDom: true, placement: 'top'})}{selectedKeys.length}行</span>
              <Button type="text" onClick={this.clearSelected} fieldid={`${this.getFieldId()}_clear_selected`}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003A', '清空已选', undefined, {returnDom: true, placement: 'top'})}</Button>
            </div>
            : <div></div>
          }
          {/* 分页 */}
          {!this.referContext.props.nonPagination ?
            <Pagination
              defaultPageSize={pageInfo.pageSize} 
              onChange={this.onChangePageIndex} 
              showJump={true}
              showSizeChanger={true}
              current={pageInfo.pageIndex}
              total={pageInfo.total}
              fieldid={`${this.getFieldId()}`}
              pageSizeOptions={["10", "20", "30", "50", "80", "100", "200", "500", "1000", "2000", "5000", "10000"]}
              onPageSizeChange={this.onPageSizeChange}
            />
            : null
          }
        </div>
        {/* } */}
      </div>
    )
  }
}
